import React from "react"

// Setup our context with initial state
const HashtagDrawerContext = React.createContext({
  isVisible: false,
  setIsVisible: () => {},
})

// Build our provider (wrapper)
export const HashtagDrawerContextProvider = ({ children }) => {
  const [isVisible, setIsVisible] = React.useState(false)

  return (
    <HashtagDrawerContext.Provider
      value={{
        isVisible,
        setIsVisible,
      }}
    >
      {children}
    </HashtagDrawerContext.Provider>
  )
}

// Make a simple export for our context for class-based components
export const withHashtagDrawerContext = Component => {
  return function WrapperComponent(props) {
    return (
      <HashtagDrawerContext.Consumer>
        {state => <Component {...props} hashtagDrawerContext={state} />}
      </HashtagDrawerContext.Consumer>
    )
  }
}

export default HashtagDrawerContext
